import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SystemContext from "@context/SystemContext";

// Função auxiliar para centralizar envios ao GTM
const pushToDataLayer = (payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

export const useInitTracking = (session) => {
  const { updateTagUser } = useContext(SystemContext);

  const [UrlCampaign, setUrlCampaign] = useState(null);
  const [stateUrlCampaign, setStateUrlCampaign] = useState(0);
  const location = useLocation();

  // 1. Leitura da UTM / Campanha
  useEffect(() => {
    if (location.search.includes("utm_campaign")) {
      setUrlCampaign(location.search);
      setStateUrlCampaign(1);
      localStorage.setItem("UrlCampaign", location.search);
    }
  }, [location.search]);

  useEffect(() => {
    logPageView(session);
  },[location.pathname, location.search, session]);

  // 2. Sincronização da Tag do Usuário e Disparo ao GTM
  useEffect(() => {
    if (session && UrlCampaign && stateUrlCampaign === 1 && updateTagUser) {
      setStateUrlCampaign(2);
      const url_search_params = new URLSearchParams(UrlCampaign);
      const campanha_name = url_search_params.get("utm_campaign");
      const ads_name = url_search_params.get("utm_content");
      const utm_source = url_search_params.get("utm_source");

      // Atualiza o contexto do app
      updateTagUser([campanha_name], {
        parameters: UrlCampaign,
        campaign: campanha_name,
        ads_name: ads_name,
        utm_source: utm_source,
      });

      // Dispara os dados de UTM para o GTM
      pushToDataLayer({
        event: "campaign_captured",
        campaign_name: campanha_name,
        ads_name: ads_name,
        utm_source: utm_source,
        parameters: UrlCampaign,
      });
    }
  }, [UrlCampaign, session, stateUrlCampaign, updateTagUser]);
};

export const logPageView = (session) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
    user_id: session?.sub || null,
    user_type: session?.my_user?.typeUser || null,
    profile: session?.my_user?.profile || null,
  });
};

export const syncTrackingUser = (session) => {
  if (session?.sub) {
    pushToDataLayer({
      event: "user_identified",
      user_id: session.sub,
      user_type: session?.my_user?.typeUser,
      profile: session?.my_user?.profile,
    });
  }
};